import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/wholeMentor/page',
    add:'/api-ir/bachelor/wholeMentor/add',
    del:'/api-ir/bachelor/wholeMentor/delete/',
    update:'/api-ir/bachelor/wholeMentor/edit',
    info:'/api-ir/bachelor/wholeMentor/get/',
}
// 查询试卷抽查列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}

export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}

export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}

export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}

export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}